var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCityActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#fff",
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.3795 18.1105-5.5151-12.72717c-.1001-.23289-.3298-.38333-.5829-.38333h-.4241v1.62634c0 .35125-.2851.63642-.6364.63642-.0013 0-.0029-.00032-.0041-.00032-.0013 0-.0029.00032-.0042.00032-.3519 0-.6364-.28517-.6364-.63642v-1.62634h-.4244c-.2538 0-.4831.15044-.5838.38333l-5.51548 12.72717c-.08533.196-.06608.4221.05196.6021.11805.1796.31789.2874.53217.2874h5.93885v-2.4751c0-.3519.2849-.6358.6364-.6358.0013 0 .0029.0006.0042.0006s.0029-.0006.0042-.0006c.3516 0 .6361.2849.6361.6358v2.4751h5.9398c.2143 0 .4141-.1081.5315-.2874.1178-.18.137-.4061.0517-.6021zm-6.5237-4.8858c0 .3526-.2851.6358-.6361.6358-.0012 0-.0028 0-.0041 0-.001 0-.0029 0-.0042 0-.3519 0-.6364-.2845-.6364-.6358v-3.29885c0-.35125.2845-.63642.6364-.63642.0013 0 .0029.00032.0042.00032s.0029-.00032.0041-.00032c.3523 0 .6361.28517.6361.63642z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityActive);
export default __webpack_public_path__ + "static/media/city_active.a89e0974b172c63def766c8efa8aa4a3.svg";
export { ForwardRef as ReactComponent };